import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

export default function MontadorPerfilFiscal() {
  const [cnpjStatus, setCnpjStatus] = useState("sem_cnpj");
  const [cnpj, setCnpj] = useState("");
  const [interesse, setInteresse] = useState("");
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    api.get("/montador/perfil-fiscal").then(r => {
      if (r.data?.cnpj_status) setCnpjStatus(r.data.cnpj_status);
      if (r.data?.cnpj) setCnpj(r.data.cnpj);
      if (r.data?.interesse_regularizacao) setInteresse(r.data.interesse_regularizacao);
    }).catch(() => {});
  }, []);

  const salvar = async () => {
    if (cnpjStatus === "ativo" && !cnpj.trim()) { toast.error("Informe o CNPJ"); return; }
    if (["inapto","sem_cnpj"].includes(cnpjStatus) && !interesse) {
      toast.error("Informe interesse em regularizar / abrir MEI"); return;
    }
    setSalvando(true);
    try {
      await api.post("/montador/perfil-fiscal", {
        cnpj_status: cnpjStatus,
        cnpj: cnpjStatus === "ativo" ? cnpj : null,
        interesse_regularizacao: interesse || null,
      });
      toast.success("Perfil fiscal atualizado");
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setSalvando(false); }
  };

  const mostraInteresse = cnpjStatus === "inapto" || cnpjStatus === "sem_cnpj";

  return (
    <>
      <div className="max-w-3xl mx-auto p-6 space-y-5">
        <div className="border border-border bg-white p-6 space-y-4">
          <div>
            <Label className="label-cap">Qual sua situação atual?</Label>
            <div className="grid md:grid-cols-3 gap-3 mt-3">
              {[
                { v: "ativo", t: "CNPJ Ativo", d: "Possuo CNPJ regular" },
                { v: "inapto", t: "CNPJ Inapto", d: "Tenho mas está irregular" },
                { v: "sem_cnpj", t: "Não Possuo", d: "Apenas CPF" },
              ].map(opt => (
                <label key={opt.v}
                  className={`border-2 p-4 cursor-pointer ${cnpjStatus === opt.v ? "border-[#142766] bg-[#142766]/5" : "border-border"}`}
                  data-testid={`pf-${opt.v}`}>
                  <input type="radio" checked={cnpjStatus === opt.v}
                    onChange={() => setCnpjStatus(opt.v)} className="sr-only" />
                  <div className="font-bold text-sm">{opt.t}</div>
                  <div className="text-xs text-muted-foreground mt-1">{opt.d}</div>
                </label>
              ))}
            </div>
          </div>

          {cnpjStatus === "ativo" && (
            <div>
              <Label className="text-xs">Número do CNPJ</Label>
              <Input value={cnpj} onChange={(e) => setCnpj(e.target.value)} placeholder="00.000.000/0001-00"
                data-testid="pf-cnpj" className="mt-1" />
            </div>
          )}

          {mostraInteresse && (
            <div className="border-t border-border pt-4">
              <Label className="label-cap">
                Você tem interesse em regularizar ou abrir MEI?
              </Label>
              <p className="text-xs text-muted-foreground mt-1 mb-3">
                Não cria obrigação. Apenas registra interesse para parcerias futuras (contábeis, planos de benefícios etc).
              </p>
              <Select value={interesse} onValueChange={setInteresse}>
                <SelectTrigger className="max-w-sm" data-testid="pf-interesse"><SelectValue placeholder="Selecione" /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="sim">Sim, quero regularizar / abrir MEI</SelectItem>
                  <SelectItem value="talvez">Talvez no futuro</SelectItem>
                  <SelectItem value="nao">Não tenho interesse</SelectItem>
                </SelectContent>
              </Select>
            </div>
          )}

          <Button onClick={salvar} disabled={salvando}
            className="w-full mt-3 h-12 btn-sharp brand-bg text-white" data-testid="pf-salvar">
            {salvando ? "Salvando…" : "Salvar perfil fiscal"}
          </Button>
        </div>

        <div className="text-xs text-muted-foreground border-l-4 border-border pl-3">
          <strong>Atenção:</strong> a regularização fiscal é responsabilidade individual do prestador autônomo.
          Empresas podem exigir CNPJ ativo para liberar atendimentos — sem CNPJ, parte das oportunidades não estará disponível.
        </div>
      </div>
    </>
  );
}
